import React from 'react';
import css from './TestimonialCard.module.css';

const TestimonialCard = ({ name, image, feedback }) => {
  return (
    <div className={css['testimonial-card']}>
      <div className={css['testimonial-header']}>
        <img src={image} alt={name} className={css['testimonial-image']} />
        <h3 className={css['testimonial-name']}>{name}</h3>
      </div>
      <p className={css['testimonial-feedback']}>“{feedback}”</p>
    </div>
  );
};

export default TestimonialCard;
